import './product-intro.scss';
import Swiper from 'swiper';
import { A11y, Pagination, Keyboard } from 'swiper/modules';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { scrollPageTo } from '../../utilities/js/scroll-to';
import stickybits from 'stickybits';

class ProductIntro {
    constructor ($productIntro) {
        this.$productIntro = $productIntro;
        this.$slider = this.$productIntro.querySelector('[data-product-intro="slider"]');
        this.slider = undefined;
        this.$pagination = this.$productIntro.querySelector('[data-product-intro="pagination"]');
        this.$imageZooms = this.$productIntro.querySelectorAll('[data-product-intro="image-zoom"]');
        this.$detailImage = this.$productIntro.querySelector('[data-project-intro="detail-image"]');
        this.$overlay = this.$productIntro.querySelector('[data-product-intro="overlay"]');
        this.$close = this.$productIntro.querySelector('[data-product-intro="close"]');
        this.$scrollLink = this.$productIntro.querySelectorAll('[data-product-intro="scroll"]');
        this.$scrollContainer = this.$productIntro.querySelector('[data-product-intro="scroll-container"]');
        this.$rightBox = this.$productIntro.querySelector('[data-product-intro="right-box"]');
    }

    initialize () {
        this.initSlider();
        this.bindEvents();
        this.initStickyBits();

        if (window.innerWidth >= window.OPTIONS.breakpoints.xxl) {
            this.setRightBoxMargin();
        }
    }

    bindEvents () {
        const addImageZoomEvent = ($imageZoom) => {
            $imageZoom.addEventListener('click', (e) => {
                e.preventDefault();
                if (window.innerWidth < window.OPTIONS.breakpoints.xxl) {
                    this.onImageZoom($imageZoom);
                }
            });

            $imageZoom.addEventListener('mouseenter', () => {
                if (window.innerWidth >= window.OPTIONS.breakpoints.xxl) {
                    this.onImageZoom($imageZoom);
                }
            });

            $imageZoom.addEventListener('mouseleave', () => {
                if (window.innerWidth >= window.OPTIONS.breakpoints.xxl) {
                    this.hideOverlay();
                }
            });
        };

        for (let i = 0; i < this.$imageZooms.length; i++) {
            const $imageZoom = this.$imageZooms[i];
            addImageZoomEvent($imageZoom);
        }

        if (this.$close) {
            this.$close.addEventListener('click', () => {
                this.hideOverlay();
            });
        }

        document.addEventListener('sizeMobile', () => {
            this.initSlider();
            this.removeRightBoxMargin();
        });

        document.addEventListener('sizeTablet', () => {
            this.destroySlider();
            this.removeRightBoxMargin();
        });

        document.addEventListener('sizeDesktop', () => {
            this.destroySlider();
            this.removeRightBoxMargin();
        });

        document.addEventListener('sizeWide', () => {
            this.destroySlider();
            this.setRightBoxMargin();
        });

        for (let i = 0; i < this.$scrollLink.length; i++) {
            const $scrollLink = this.$scrollLink[i];

            $scrollLink.addEventListener('click', (e) => {
                e.preventDefault();
                const targetId = $scrollLink.getAttribute('href');
                const $target = document.querySelector(targetId);

                if ($target) {
                    scrollPageTo($target);
                }
            });
        }
    }

    onImageZoom ($imageZoom) {
        const imageUrl = $imageZoom.getAttribute('href');

        if (imageUrl !== '') {
            this.setImage(imageUrl);
            this.showOverlay();
        }
    }

    initSlider () {
        if (window.innerWidth < window.OPTIONS.breakpoints.l && this.$slider && this.$pagination) {
            this.slider = new Swiper(this.$slider, {
                modules: [A11y, Pagination, Keyboard],
                a11y: true,
                keyboard: true,
                resistanceRatio: 0,
                slidesPerView: 1,
                pagination: {
                    el: this.$pagination
                }
            });
        }
    }

    destroySlider () {
        if (this.slider) {
            this.slider.destroy(true, true);
        }
    }

    setImage (imageUrl) {
        if (this.$detailImage) {
            this.$detailImage.src = imageUrl;
        }
    }

    showOverlay () {
        if (this.$overlay && this.$detailImage) {
            this.$overlay.classList.add('product-intro__overlay--visible');

            if (window.innerWidth < window.OPTIONS.breakpoints.xxl) {
                disableBodyScroll(this.$detailImage);
            }
        }
    }

    hideOverlay () {
        if (this.$overlay && this.$detailImage) {
            this.$overlay.classList.remove('product-intro__overlay--visible');

            if (window.innerWidth < window.OPTIONS.breakpoints.xxl) {
                enableBodyScroll(this.$detailImage);
            }
        }
    }

    setRightBoxMargin () {
        if (!this.$rightBox) {
            return false;
        }

        const $header = this.$productIntro.querySelector('[data-product-intro="header"]');

        if (this.$rightBox && $header) {
            const headerStyle = $header.currentStyle || window.getComputedStyle($header);
            const margin = parseInt(headerStyle.marginTop) + $header.getBoundingClientRect().height;

            this.$rightBox.style.marginTop = '-' + margin + 'px';
        }
    }

    removeRightBoxMargin () {
        if (!this.$rightBox) {
            return false;
        }

        this.$rightBox.style.marginTop = '0px';
    }

    initStickyBits () {
        if (!this.$rightBox) {
            return false;
        }

        if (this.$rightBox) {
            stickybits(this.$rightBox, {
                useStickyClasses: true
            });
        }
    }
}

export { ProductIntro };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-product-intro="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new ProductIntro($root);
            $rootAPI.initialize();
        });
    }
});
